import { render, staticRenderFns } from "./FormDynemic.vue?vue&type=template&id=1a2b0c88&scoped=true"
import script from "./FormDynemic.vue?vue&type=script&lang=js"
export * from "./FormDynemic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b0c88",
  null
  
)

export default component.exports